import ICVault from "@/components/Icon/ICNavbar/ICVault";
import { Link, useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import ICRank from "@/components/Icon/ICNavbar/ICRank.tsx";
import { getCookie } from "typescript-cookie";

export default function DesktopNavigation() {
  const { t } = useTranslation();
  // See the current pathname use `useLocation` from `@tanstack/react-router`
  const { pathname } = useLocation();
  const token = getCookie("accessToken");

  // Helper function to determine if a link is active
  const isActive = (path: string) => pathname === path;
  const isVerifyPath = pathname === "/verify" || pathname === "/not-found";

  return (
    <nav className="absolute left-1/2 transform -translate-x-1/2 lg:flex space-x-4 lg:items-center lg:justify-center hidden">
      <Link
        to="/vault"
        className={`flex gap-2 p-2 rounded-md transition-colors ${
          isActive("/vault")
            ? "bg-gray-600 text-white"
            : isVerifyPath
              ? "text-gray-600 cursor-not-allowed"
              : "text-gray-400 hover:bg-gray-600 hover:text-white"
        }`}
        onClick={isVerifyPath ? (e) => e.preventDefault() : undefined}
      >
        <ICVault width="24" height="24" className="text-[#8E8E92]" />
        {t("navbar.vault")}
      </Link>
      <Link
        to="/ranking"
        className={`flex gap-2 p-2 rounded-md transition-colors ${
          isActive("/ranking")
            ? "bg-gray-600 text-white"
            : isVerifyPath
              ? "text-gray-600 cursor-not-allowed"
              : "text-gray-400 hover:bg-gray-600 hover:text-white"
        }`}
        onClick={isVerifyPath ? (e) => e.preventDefault() : undefined}
      >
        <ICRank width="24" height="24" className="text-[#8E8E92]" />
        {t("navbar.ranks")}
      </Link>
    </nav>
  );
}
